import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "createemptycart-mutation"
    }}>{`createEmptyCart mutation`}</h1>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`The `}<inlineCode parentName="p">{`createEmptyCart`}</inlineCode>{` mutation has been deprecated. Use the `}<a parentName="p" {...{
        "href": "create-guest-cart.md"
      }}>{`createGuestCart`}</a>{` mutation instead.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`createEmptyCart`}</inlineCode>{` mutation creates an empty shopping cart for a guest or logged in customer. You can allow the system to generate a cart ID, or assign a specific ID.`}</p>
    <p>{`If you are creating a cart for a logged in customer, you must include the customer's authorization token in the header of the request.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  createEmptyCart {
    String
  }
}
`}</code></pre>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#mutation-createEmptyCart"
      }}><inlineCode parentName="a">{`createEmptyCart`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this mutation.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <h3 {...{
      "id": "create-a-cart-with-a-randomly-generated-cart-id"
    }}>{`Create a cart with a randomly-generated cart ID`}</h3>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  createEmptyCart
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <p>{`The response is the cart ID, which is sometimes called the quote ID. The remaining examples in this topic will use this cart ID.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "createEmptyCart": "4JQaNVJokOpFxrykGVvYrjhiNv9qt31C"
  }
}
`}</code></pre>
    <h3 {...{
      "id": "create-an-empty-cart-with-an-assigned-cart-id"
    }}>{`Create an empty cart with an assigned cart ID`}</h3>
    <p>{`You can also create an empty cart with a specified `}<inlineCode parentName="p">{`cart_id`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  createEmptyCart(
    input: {
      cart_id: "x2345678901234567890123456789012"
    }
  )
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <p>{`The mutation returns the same `}<inlineCode parentName="p">{`cart_id`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "createEmptyCart": "x2345678901234567890123456789012"
  }
}
`}</code></pre>
    <h2 {...{
      "id": "errors"
    }}>{`Errors`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Cart with ID "XXX" already exists.`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The specified cart ID was previously used to create a cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Cart ID length should to be 32 symbols.`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The cart ID is not the required length.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      